import { getDepositDetail, businessGetAccountInfo,getRateInfoAPI } from "@/apis/crypto";
import { getServerTime } from "@/utils/tool";
import { Toast } from "antd-mobile";
import { StateCreator } from "zustand";
import { CryptoTradingOrderType, CryptoTradingStateType, initialState } from "./initialState";
import  QRCode  from "qrcode";

interface CryptoTradingActionType {
  // *** /
  fetchDepositDetail: (isBuyVb: boolean, orderType: CryptoTradingOrderType) => Promise<any>;
  fetchBusinessGetAccountInfo: (type:string) => Promise<any>
}

export type CryptoTradingStoreType = CryptoTradingStateType & CryptoTradingActionType;


// export const createStore = ()=> create<Store>((set, get) => ({
  
// }));

// 将 useStore 改为 createStore， 并把它改为 create 方法
export const StoreCreator:StateCreator<CryptoTradingStoreType> = (set, get) => {
  const finishedCountDown = () =>{
    const { timer } = get();
    console.log('清空计时器==',timer);
    timer && clearTimeout(timer);
    set({countdown:0, timer: null});
  }

  const updateQRcode =  (str: string) => {
    const { cryptoAccountInfo } = get();
    QRCode.toDataURL(str || cryptoAccountInfo.address).then((url: string) => {
      const $QRcode = document.querySelector(".QRcode");
      $QRcode && $QRcode.setAttribute("src", url);
    });
  }
  
  const fetchDepositDetail = async (isBuyVb: boolean = false, orderType: CryptoTradingOrderType) => {
    //是否购买V币  true amount为amount  否则 copeAmount
    set({ loading:true, orderType });
    const { ok, data, msg } = await getDepositDetail({ orderType });
    const {fetchDepositDetail, timer} = get();
    if (ok) {
      if (data) {
        // 有未完成的订单
        const parmas = {
          orderInfo: data.order,
          form: {
            amount: isBuyVb ? data.order.amount : data.order.copeAmount,
            paymentType: data.order.paymentType,
            receivingAddress:'',
          },
          cryptoAccountInfo:{
            address: data.order.receivingAddress,
            otcTicker: data.order.feeRate,//汇率
            // otcTicker: parseFloat(
            //   String(data.order.amount / data.order.copeAmount)
            // ).toFixed(2)
          },
          timer,//记录计时器
        }
        if( orderType === 'ChangeUsdt'){
          // parmas.cryptoAccountInfo.otcTicker = data.order.feeRate;
          parmas.form.amount = data.order.amount;
        }
        set(parmas);
        
        updateQRcode(data.address);
        // 订单超时时间
        if (data.currentStateExpireTime && data.currentStateExpireTime.expire) {
          let nextCountdown = 0;
          let nextTimer = null;
          const now = getServerTime();
          nextCountdown = data.currentStateExpireTime.expire * 1000 - now;
          // 如果可以倒计时
          if (nextCountdown > 0) {
            if(timer){
              clearTimeout(timer);
            }
            nextTimer = setTimeout(() => fetchDepositDetail(isBuyVb, orderType), 5000);
            set({countdown: nextCountdown, timer: nextTimer});
            
          }else{
            finishedCountDown();
          }
        }
      } else {
        // 没有未完成的订单
        finishedCountDown();
      }
    } else {
      Toast.show(msg);
    }
  };

  const fetchBusinessGetAccountInfo = async (val: string) => {
    const { ok, data, msg, ...rest } = await businessGetAccountInfo({ type: val });
    if (ok) {
      set({ cryptoAccountInfo: data });
      getRateInfoFun('IN');
      updateQRcode(data.address);
    } else {
      Toast.show(msg);
    }

    return { ok, data, msg, ...rest };
  };

  const getRateInfoFun = async (val: string) => {
    const { cryptoAccountInfo } = get();
    const { ok, data, msg } = await getRateInfoAPI({ type: val });
    if (ok) {
      // set({ cryptoAccountInfo: {...cryptoAccountInfo,[val]:data.otcTicker} });
      set({ cryptoAccountInfo: {...cryptoAccountInfo,otcTicker:data.otcTicker} });
    } else {
      Toast.show(msg);
    }
  };


  return {
    ...initialState,
    fetchDepositDetail,
    fetchBusinessGetAccountInfo,
    getRateInfoFun,
    finishedCountDown,
    
  }
}